import User from '../../../client/models/user'
import Vote from './vote'
import Comment from './comment'
import Material from './material'

export default class UserAnswer {
  readonly id: number
  readonly accepted: number
  readonly user: User
  readonly votes: Vote[] = []
  readonly createdAt: string
  readonly updatedAt: string
  readonly comments: Comment[] = []
  readonly materials: Material[] = []
  readonly renderedBody: string
  body: string
  files: File[] = []
  showCommentForm: boolean = false
  isEditing: boolean = false

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.body = data.body
    this.renderedBody = data.renderedBody
    this.accepted = data.accepted
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt

    if (data.user) {
      this.user = new User(data.user)
    }
    if (data.votes) {
      this.votes = data.votes.map((element) => new Vote(element))
    }
    if (data.comments) {
      this.comments = data.comments.map((element) => new Comment(element))
    }
    if (data.materials) {
      this.materials = data.materials.map((element) => new Material(element))
    }
    this.files = []
    this.showCommentForm = false
    this.isEditing = false
  }

  public get voteMark(): number {
    return this.votes.reduce((sum, vote) => sum + vote.value, 0)
  }
}
